import React, { type ReactNode, useEffect, useState } from 'react';
import { type ConnectedProps, connect } from 'react-redux';

import { autoLogout } from 'actions';
import { Spinner } from 'components/Spinner/Spinner';
import type { RootState } from 'reducers/types';
import { hasGatewayOrigin } from 'selectors';

type AutologoutProps = ConnectedProps<typeof connector> & {
  children?: ReactNode;
};

// migrate AutologoutComponent to functional component
const AutologoutComponent = ({
  autoLogout,
  children,
  hasGatewayOrigin,
}: AutologoutProps) => {
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    const fetchAutoLogout = async () => {
      if (hasGatewayOrigin) {
        await autoLogout();
      }

      setIsFetching(false);
    };

    fetchAutoLogout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isFetching ? <Spinner /> : children;
};

const mapStateToProps = (state: RootState) => ({
  hasGatewayOrigin: hasGatewayOrigin(state),
});

const mapDispatchToProps = { autoLogout };

const connector = connect(mapStateToProps, mapDispatchToProps);
const Autologout = connector(AutologoutComponent);

export { Autologout };
